<template>
  <div class="profile">
    <div class="container">
      <el-tabs
        tab-position="left"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="个人信息" name="1">
          <el-row>
            <el-col :span="12">
              <el-col :span="16">
                <div class="volunteerCard">
                  <img
                    id="printid1"
                    :src="baseurl + accountInfo.volunteerCard"
                    alt=""
                  />
                  <div
                    class="shade"
                    @click="downLoadimg(baseurl + accountInfo.volunteerCard)"
                  >
                    下载
                  </div>
                </div>
              </el-col>
              <el-col :span="8" class="printboxcol">
                <div class="printbox">
                  <el-upload
                    class="upload-demo"
                    :show-file-list="false"
                    :action="baseurl + '/volunteer/volunteer/uploadImg'"
                    :on-success="successcard"
                    name="img"
                    :data="{ id: this.accountInfo.id }"
                  >
                    <el-button size="small" type="success">头像上传</el-button>
                  </el-upload>
                  <el-button size="small" type="primary" v-print="'#printid1'"
                    >证件打印</el-button
                  >
                  <!-- <el-button size="small" type="primary" @click="test">证件打印</el-button>
                  <a class="target" ref="target" href="" target="_blank"></a> -->
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="16">
                <div class="volunteerCard">
                  <img
                    id="printid2"
                    :src="baseurl + '/upload/volunteerCard/back.jpg'"
                    alt=""
                  />
                  <div
                    class="shade"
                    @click="
                      downLoadimg(baseurl + '/upload/volunteerCard/back.jpg')
                    "
                  >
                    下载
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="printbox">
                  <el-button size="small" type="primary" v-print="'#printid2'"
                    >证件打印</el-button
                  >
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <div>
                <span class="infolabel">姓名</span>：
                {{ accountInfo.realName }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">身份证号</span>：
                {{ accountInfo.idnumber }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">手机号</span>：
                {{ accountInfo.phone }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">密码</span>： **********
                <el-button
                  type="primary"
                  size="mini"
                  @click="passwordFlag = true"
                  >修改密码</el-button
                >
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">居住地址</span>：
                {{ accountInfo.allAddress }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">电子邮箱</span>：
                {{ accountInfo.email }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">性别</span>：
                {{ accountInfo.sex }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">民族</span>：
                {{ accountInfo.nation }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">政治面貌</span>：
                {{ accountInfo.politics }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">从事职业</span>：
                {{ accountInfo.profession }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">服务类型</span>：
                {{ accountInfo.publishId }}
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">所属志愿服务队</span>：
                {{ accountInfo.organizationName }}
                <el-button
                  v-if="!accountInfo.organizationId"
                  type="primary"
                  size="mini"
                  @click="joinTeamFlagtip"
                  >加入志愿队</el-button
                >
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="infolabel">在队职务</span>：
                {{ accountInfo.roleName }}
              </div>
            </el-col>
            <el-col :span="24">
              <div>
                <span class="infolabel">个人简介</span>：
                {{ accountInfo.introduction }}
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="组织管理" name="2">
          <div>
            <el-button
              type="primary"
              @click="joinTeamFlagtip"
              v-if="!accountInfo.organizationId"
              >加入志愿队</el-button
            >
            <el-button type="primary" @click="outTeam">退出志愿队</el-button>
            <el-button
              type="primary"
              @click="serverFlag = true"
              v-if="!accountInfo.organizationId"
              >申请志愿队</el-button
            >
            <el-button
              type="primary"
              @click="dissolveTeam"
              v-if="roleName == '队长'"
              >解散志愿队</el-button
            >
            <el-button
              type="primary"
              @click="moveTeamFlag = true"
              v-if="roleName == '队长'"
              >转让志愿队</el-button
            >
          </div>
          <div class="member_table" v-if="roleName == '队长'">
            <el-table :data="memberList" stripe border style="width: 100%">
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column prop="realName" label="姓名"> </el-table-column>
              <el-table-column prop="profession" label="从事职业">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="memberHandleClick(scope.row)"
                    type="text"
                    size="small"
                    >增加积分</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="member_pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="memberTotal"
                :page-size="memberDataform.limit"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="活动报道" name="3" v-if="roleName == '队长'">
          <el-form
            :model="dataForm2"
            :rules="dataRule"
            ref="dataForm2"
            label-width="80px"
          >
            <el-form-item label="标题" prop="title">
              <el-input v-model="dataForm2.title" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="depict">
              <el-input
                v-model="dataForm2.depict"
                placeholder="简介"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布类型" prop="publishTypeId">
              <el-select
                v-model="dataForm2.publishTypeId"
                placeholder="发布类型"
              >
                <el-option
                  :label="item.typeName"
                  :value="item.id"
                  :key="item.id"
                  v-for="item in typeList"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="封面图片" prop="img">
              <el-upload
                class="avatar-uploader"
                :action="baseurl + '/organization/organization/uploadLogoImg'"
                :show-file-list="false"
                :on-success="headerhandleAvatarSuccess"
                name="img"
              >
                <img
                  v-if="dataForm2.img"
                  :src="baseurl + dataForm2.img"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="发布时间" prop="publishTime">
              <el-date-picker
                v-model="dataForm2.publishTime"
                type="date"
                placeholder="发布时间"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="志愿活动" prop="activityId">
              <el-select
                v-model="dataForm2.activityId"
                clearable
                placeholder="志愿活动"
              >
                <el-option
                  :label="item.activityName"
                  :value="item.id"
                  :key="item.id"
                  v-for="item in activityList"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="组织id" prop="organizationId">
          <el-input v-model="dataForm2.organizationId" placeholder="组织id"></el-input>
      </el-form-item> -->
            <!-- <el-form-item label="志愿活动标题" prop="acticityName">
          <el-input v-model="dataForm2.acticityName" placeholder="志愿活动标题"></el-input>
      </el-form-item> -->
            <!-- <el-form-item label="组织名称" prop="organizationName">
          <el-input v-model="dataForm2.organizationName" placeholder="组织名称"></el-input>
      </el-form-item> -->
            <el-form-item label="内容" prop="content">
              <editor-bar
                v-model="dataForm2.content"
                :isClear="isClear"
                @change="change"
              ></editor-bar>
            </el-form-item>
            <div class="wangeditor"></div>
            <el-form-item v-if="dataForm2.id" label="审核状态" prop="status">
              <el-select v-model="dataForm2.status" placeholder="审核状态">
                <el-option
                  v-for="item in statusOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="buttom_btn">
            <el-button type="primary" @click="dataFormSubmitHandle()"
              >提交活动报道</el-button
            >
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane> -->
      </el-tabs>
    </div>

    <!-- 增加积分 start -->
    <div class="changepassword" v-if="integralFlag">
      <div class="login_info">
        <h3 class="login-title">增加积分</h3>
        <el-form
          :model="integralDataform"
          :rules="integralRules"
          ref="integralRef"
          status-icon
          label-width="70px"
        >
          <el-form-item prop="username" label="积分">
            <el-input
              v-model="integralDataform.num"
              type="number"
              placeholder="增加积分"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password" label="备注">
            <el-input
              v-model="integralDataform.content"
              placeholder="增加积分备注"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div class="login_bit">
          <el-button class="w-percent-100" @click="integralFlag = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="integralSubmit()"
            class="w-percent-100"
            >确认</el-button
          >
        </div>
      </div>
    </div>
    <!-- 增加积分 end -->

    <!-- 修改密码 start -->
    <div class="changepassword" v-if="passwordFlag">
      <div class="login_info">
        <h3 class="login-title">修改密码</h3>
        <el-form
          :model="dataForm"
          :rules="rules"
          ref="dataForm"
          status-icon
          label-width="70px"
        >
          <el-form-item prop="password" label="旧密码">
            <el-input v-model="dataForm.password" placeholder="旧密码">
            </el-input>
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码">
            <el-input
              v-model="dataForm.newPassword"
              type="password"
              placeholder="新密码"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password2" label="确认密码">
            <el-input
              v-model="dataForm.password2"
              type="password"
              placeholder="确认密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="login_bit">
          <el-button class="w-percent-100" @click="passwordFlag = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="changepassword()"
            class="w-percent-100"
            >确认</el-button
          >
        </div>
      </div>
    </div>
    <!-- 修改密码 end -->
    <!-- 加入组织 start -->
    <div class="changepassword" v-if="joinTeamFlag">
      <div class="login_info">
        <h3 class="login-title">加入组织</h3>
        <div style="margin: 15px 0">
          <el-form status-icon label-width="90px">
            <el-form-item prop="teamId" label="组织选择">
              <el-select
                v-model="teamId"
                placeholder="请选择"
                :rules="[{ required: true, message: '必选项不能为空' }]"
              >
                <el-option
                  v-for="item in teamList"
                  :key="item.id"
                  :label="item.organizationName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="login_bit">
          <el-button class="w-percent-100" @click="joinTeamFlag = false"
            >取消</el-button
          >
          <el-button type="primary" @click="joinTeam" class="w-percent-100"
            >确认</el-button
          >
        </div>
      </div>
    </div>
    <!-- 加入组织 end -->
    <!-- 转让组织 start -->
    <div class="changepassword" v-if="moveTeamFlag">
      <div class="login_info">
        <h3 class="login-title">转让组织</h3>
        <div style="margin: 15px 0">
          <el-form status-icon label-width="90px" :rules="moveTeamRules">
            <el-form-item prop="transferorId" label="转让人">
              <el-select v-model="transferorId" placeholder="请选择">
                <el-option
                  v-for="item in userlist"
                  :key="item.userId"
                  :label="item.realName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="login_bit">
          <el-button class="w-percent-100" @click="moveTeamFlag = false"
            >取消</el-button
          >
          <el-button type="primary" @click="moveTeam" class="w-percent-100"
            >确认</el-button
          >
        </div>
      </div>
    </div>
    <!-- 转让组织 end -->
    <!-- 志愿服务队申请 start -->
    <div class="changepassword" v-if="serverFlag">
      <div class="login_info" style="width: 500px">
        <h3 class="login-title">志愿服务队申请</h3>
        <div style="margin: 15px 0">
          <el-form
            status-icon
            label-width="155px"
            ref="teamRef"
            :rules="teamRules"
            :model="teamDataForm"
          >
            <el-form-item prop="organizationName" label="志愿者服务队名称:">
              <el-col :span="7"> 红十字曜阳养老 </el-col>
              <el-col :span="9">
                <el-input
                  v-model="teamDataForm.organizationName"
                  placeholder="志愿者服务队名称"
                ></el-input>
              </el-col>
              <el-col :span="6"> 志愿服务队 </el-col>
            </el-form-item>
            <el-form-item prop="type" label="志愿服务队所属组织:">
              <el-select v-model="teamDataForm.type" placeholder="请选择">
                <el-option
                  v-for="item in serveroptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="realName" label="所属组织机构名称:">
              <el-input
                v-model="teamDataForm.realName"
                placeholder="组织机构名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="志愿服务队所在地区" prop="allAddress">
              <el-cascader
                ref="myCascader"
                :props="props"
                v-model="teamDataForm.allAddress"
                @change="changeAdress"
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="scale" label="志愿服务队人数:">
              <el-input
                v-model="teamDataForm.scale"
                placeholder="志愿服务队人数"
              ></el-input>
            </el-form-item>
            <el-form-item prop="content" label="志愿服务队简介:">
              <el-input
                v-model="teamDataForm.content"
                type="textarea"
                placeholder="志愿服务队简介"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="组织标识" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="baseurl + '/organization/organization/uploadLogoImg'"
                :show-file-list="false"
                :on-success="logohandleAvatarSuccess"
                name="img"
              >
                <img
                  v-if="teamDataForm.logo"
                  :src="baseurl + teamDataForm.logo"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="login_bit">
          <el-button class="w-percent-100" @click="serverFlag = false"
            >取消</el-button
          >
          <el-button type="primary" @click="submitTeam" class="w-percent-100"
            >确认</el-button
          >
        </div>
      </div>
    </div>
    <!-- 志愿服务队申请 end -->
  </div>
</template>

<script>
import EditorBar from "../../components/wangEnduit";
export default {
  name: "profile",
  data() {
    let That = this;
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.dataForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          if (level == 0) {
            var params = {
              code: "",
              level: "1",
            };
          } else {
            var params = {
              code: node.value,
              level: level + 1,
            };
          }
          That.$http
            .get(
              `City/city/getAllCity2?code=${params.code}&level=${params.level}`
            )
            .then((res) => {
              if (res.data.code == 0) {
                const nodes = res.data.data.map((item) => ({
                  value: item.criCode,
                  label: item.criName,
                  leaf: parseInt(item.criLevel) - 1 >= 2,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            });
        },
      },
      activeName: "1",
      baseurl: this.$baseurl,
      teamId: "",
      allAddress: "",
      teaminput: "",
      teamselect: "",
      serverselect: "",
      serverFlag: false,
      joinTeamFlag: false,
      passwordFlag: false,
      integralFlag: false,
      moveTeamFlag: false,
      integralDataform: {
        userIds: "",
        num: "",
        content: "",
      },
      accountInfo: {},
      dataForm: {
        newPassword: "",
        password: "",
        password2: "",
      },
      teamDataForm: {
        organizationName: "",
        type: "",
        realName: "",
        logo: "",
        allAddress: "",
        scale: "",
        content: "",
      },
      options: [
        { value: "111", label: "北京" },
        { value: "222", label: "上海" },
      ],
      serveroptions: [
        { value: "1", label: "社会组织" },
        { value: "2", label: "单位/公司组织" },
        { value: "3", label: "养老机构组织" },
        { value: "4", label: "其他" },
      ],
      rules: {
        password: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        password2: [{ validator: validatePass2, trigger: "blur" }],
      },
      moveTeamRules: {
        transferorId: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
      },
      integralRules: {
        num: [{ required: true, message: "必填项不能为空", trigger: "blur" }],
        content: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
      },
      integralRules: {
        organizationName: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
      },
      teamRules: {
        organizationName: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        type: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        realName: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        logo: [{ required: true, message: "必填项不能为空", trigger: "blur" }],
        allAddress: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        scale: [{ required: true, message: "必填项不能为空", trigger: "blur" }],
        content: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
      },
      isExistsUrlOption: [
        { label: "不存在", value: "0" },
        { label: "存在", value: "1" },
      ],
      statusOption: [
        { label: "通过", value: 2 },
        { label: "不通过", value: 3 },
        { label: "审核中", value: 1 },
      ],
      isClear: false,
      visible: false,

      dataForm2: {
        id: "",
        title: "",
        depict: "",
        publishTypeId: "",
        img: "",
        isExistsUrl: "",
        url: "",
        content: "",
        delFlag: "",
        updater: "",
        creator: "",
        updateDate: "",
        createDate: "",
        status: "",
        contentimages: "",
        docUrl: "",
        publishTime: "",
        provenance: "",
        activityId: "",
        organizationId: "",
        acticityName: "",
        organizationName: "",
      },
      typeList: [],
      activityList: [],
      teamList: [],
      userlist: [],
      baseurl: this.$baseurl,
      memberList: [],
      memberTotal: 0,
      memberDataform: {
        page: 1,
        limit: 20,
        status: 2,
      },
      roleName: "",
      transferorId: "",
    };
  },
  computed: {
    dataRule() {
      return {
        title: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        depict: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        publishTypeId: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        img: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        isExistsUrl: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        delFlag: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        updater: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        updateDate: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        contentimages: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        docUrl: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        publishTime: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        provenance: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        organizationId: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        acticityName: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        organizationName: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
      };
    },
  },
  components: {
    EditorBar,
  },
  mounted() {
    this.getUserInfo();
    // console.log(localStorage.getItem("accountinfo"))
    // this.accountInfo = JSON.parse(localStorage.getItem("accountinfo"));
    // this.roleName = JSON.parse(localStorage.getItem("accountinfo")).roleName;
    this.gettype();
    this.getActivityList();
    this.getTeamList();
    this.getMemberList();
    this.getTeamUser();
  },
  methods: {
    joinTeamFlagtip(){
       this.$confirm(
        "志愿者未满16周岁时，加入志愿队申请通过后，该志愿者的监护人将自动加入志愿队， 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
      this.joinTeamFlag = true
        })
    },
    // test() {
    //     let target = this.$refs.target
    //     target.setAttribute('href', window.location.origin + '/home/integral-record')
    //     target.click()
    //   },
    successcard(a, b, c) {
      this.$message.warning("上传完成，请刷新页面！");
    },
    async getUserInfo() {
      let {
        data: { data, code },
      } = await this.$http.get("/sys/user/info");
      if (code != 0) return;
      this.getAccountInfo(data.volunteerId);
      this.tokenflag = true;
      // this.accountInfo=data
      // localStorage.setItem("userinfo", JSON.stringify(data));
      // this.$router.push('/')
    },
    async getAccountInfo(id) {
      let {
        data: { code, data },
      } = await this.$http.get("/volunteer/volunteer/selectDetailById/" + id);
      console.log(data);
      if (code != 0) return;
      localStorage.setItem("accountinfo", JSON.stringify(data));
      this.accountInfo = data;
      this.roleName = data.roleName;
    },
    async moveTeam() {
      let { realName: transferorName } = this.userlist.find(
        (item) => item.userId == this.transferorId
      );
      let { realName: applicantName, userId: applicantId } = JSON.parse(
        localStorage.getItem("accountinfo")
      );
      let formdata = {
        transferorId: this.transferorId,
        transferorName,
        applicantName,
        applicantId,
      };
      let {
        data: { code },
      } = await this.$http.post("/Change/change", formdata);
      if (code != 0) return this.$message.warning("转让队长职务申请提交失败！");
      this.$message.success("转让队长职务申请提交成功！");
      this.moveTeamFlag = false;
    },
    async getTeamUser() {
      let { organizationId, userId } = JSON.parse(
        localStorage.getItem("accountinfo")
      );
      let {
        data: { data, code },
      } = await this.$http.get("volunteer/volunteer/selectVolunteer", {
        params: { organizationId, userId },
      });
      if (code != 0) return;
      this.userlist = data;
    },
    handleCurrentChange(page) {
      this.memberDataform.page = page;
      this.getMemberList();
    },
    // 切换tab调用接口
    handleClick(tab, event) {
      if (this.activeName == 2) {
        console.log(this.accountInfo.organizationId);
        this.memberDataform.organizationId = this.accountInfo.organizationId;
        this.memberDataform.limit = 20;
        this.getMemberList();
      }
    },
    memberHandleClick(row) {
      this.integralDataform.userIds = row.userId;
      this.integralDataform.operatorId = this.accountInfo.userId;
      this.integralFlag = true;
    },
    async integralSubmit() {
      let type = false;
      this.$refs.integralRef.validate((volid) => {
        if (!volid) type = true;
      });
      if (type) return;

      let {
        data: { code },
      } = await this.$http.get("/Integral/integral/creatList", {
        params: this.integralDataform,
      });
      if (code != 0) return this.$message.warning("增加积分失败！");
      this.$message.success("积分增加成功");
      this.integralFlag = false;
    },
    async getMemberList() {
      let {
        data: { data, code },
      } = await this.$http.get("/volunteer/volunteer/page", {
        params: this.memberDataform,
      });
      if (code != 0) return;
      this.memberList = data.list;
      this.memberTotal = data.total;
    },
    async dataFormSubmitHandle() {
      this.dataForm2.userId = this.accountInfo.userId;
      let {
        data: { code },
      } = await this.$http.post("/api/information/", this.dataForm2);
      if (code != 0) return this.$message.warning("活动报道发布失败！");
      this.$message.success("活动报道发布成功!");
    },
    change(v) {
      console.log(v);
      if (v == 2) {
        this.memberDataform.limit = 20;
        this.getMemberList();
      }
    },
    dissolveTeam() {
      this.$confirm(
        "队伍解散,所有成员自动转换为社会志愿者, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let dataform = JSON.parse(localStorage.getItem("accountinfo"));
          dataform.publishId = "";
          this.$http
            .put("volunteer/volunteer/dissolveOrganization", dataform)
            .then(({ data: { code, msg } }) => {
              if (code != 0) return this.$message.warning(msg?msg:"解散队伍失败！");
              this.$message.success("队伍已解散,所有成员自动转换为社会志愿者");
              this.getUserInfo()
            });
        })
        .catch(() => {});
    },
     outTeam() {
      this.$confirm("此操作将退出志愿队, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then ( async () => {
          let dataform = JSON.parse(localStorage.getItem("accountinfo"));
          dataform.publishId = "";
          let {
            data: { code, msg },
          } = await this.$http.put("/volunteer/volunteer/out", dataform);
          if (code != 0)
            return this.$message.warning(msg ? msg : "退出志愿队失败！");
          this.$message.success("退出志愿队成功！");
          this.getUserInfo();
        })
        .catch(() => {});
    },
    async joinTeam() {
      let dataform = JSON.parse(localStorage.getItem("accountinfo"));
      dataform.organizationId = this.teamId;
      dataform.publishId = "";
      let {
        data: { code, msg },
      } = await this.$http.put("/volunteer/volunteer/join", dataform);
      if (code != 0)
        return this.$message.warning(msg ? msg : "加入组织申请提交失败！");
      this.joinTeamFlag = false;
      if (code == 500)
        return this.$message.warning("已经有加入申请,请耐心等待审核！");
      this.$message.success("加入组织申请提交成功！");
    },
    async getTeamList() {
      let {
        data: { data, code },
      } = await this.$http.get("/organization/organization/page", {
        params: { page: 1, limit: 999999, status: 2 },
      });
      if (code != 0) return;
      this.teamList = data.list;
    },
    changeAdress(value) {
      console.log(this.$refs["myCascader"].inputValue);
    },
    logohandleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code != 0) return;
      this.teamDataForm.logo = res.data.logo;
    },
    headerhandleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code != 0) return;
      this.dataForm2.img = res.data.logo;
    },
    async changepassword() {
      let {
        data: { code },
      } = await this.$http.put("/sys/user/password", this.dataForm);
      if (code == 401) return this.$message.warning("登陆状态过期，请重新登陆");
      if (code == 500) return this.$message.warning("原密码不正确,请重新填写");
      if (code != 0) return this.$message.warning("修改密码失败!");
      this.$message.success("修改密码成功！");
    },
    async getActivityList() {
      let {
        data: { code, data },
      } = await this.$http.get("/activity/volunteeractivity/page", {
        params: { page: 1, limit: 1000000 },
      });
      if (code != 0) return;
      this.activityList = data.list;
    },
    async gettype() {
      let {
        data: { data, code },
      } = await this.$http.get("api/publishtype/selectAll");
      if (code != 0) return;
      this.typeList = data;
    },
    async submitTeam() {
      let type = false;
      this.$refs.teamRef.validate((volid) => {
        if (!volid) type = true;
      });
      if (type) return;
      let { userId } = JSON.parse(localStorage.getItem("accountinfo"));
      this.teamDataForm.sheng = this.teamDataForm.allAddress[0];
      this.teamDataForm.shi = this.teamDataForm.allAddress[1];
      this.teamDataForm.qu = this.teamDataForm.allAddress[2];
      this.teamDataForm.userId = userId;
      delete this.teamDataForm.allAddress;
      let {
        data: { code, msg },
      } = await this.$http.post("/organization/organization", {
        ...this.teamDataForm,
        organizationName:
          "红十字曜阳养老" + this.teamDataForm.organizationName + "志愿服务队",
      });
      if (code != 0)
        return this.$message.warning(msg ? msg : "组织申请提交失败！");
      this.$message.success("组织申请提交成功！");
      this.activeName = "1";
      this.getUserInfo()
      this.serverFlag = false;
    },
    downLoadimg(url) {
      let src = url;
      var canvas = document.createElement("canvas");
      var img = document.createElement("img");
      img.onload = function (e) {
        canvas.width = img.width;
        canvas.height = img.height;
        var context = canvas.getContext("2d");
        context.drawImage(img, 0, 0, img.width, img.height);
        // window.navigator.msSaveBlob(canvas.msToBlob(),'image.jpg');
        // saveAs(imageDataUrl, '附件');
        canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);
        canvas.toBlob((blob) => {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "volunteer";
          link.click();
        }, "image/jpeg");
      };
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = src;
    },
  },
};
</script>

<style lang="scss">
.profile {
  padding-top: 30px;
  .printbox {
    height: 200px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
  }
  .volunteerCard {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .shade {
      width: 100%;
      height: 100px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(#000, 0.5);
      color: #fff;
      text-align: center;
      line-height: 100px;
      font-size: 36px;
      opacity: 0;
      transition: 0.5s;
      cursor: pointer;
    }
    &:hover .shade {
      opacity: 1;
    }
  }
  .member_table {
    padding: 20px 0;
    .member_pagination {
      padding-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .buttom_btn {
    display: flex;
    justify-content: flex-end;
    margin: 10px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #fff;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 2px solid #eee;
    background-color: #fff;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .infolabel {
    line-height: 3;
    display: inline-block;
    width: 120px;
    text-align-last: justify;
  }
  .changepassword {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.4);
    .login_info {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      box-shadow: 0px 0px 2px #ffffff;
      padding: 20px;
      width: 360px;
      border-radius: 10px;
      animation: totop 0.5s;
      .el-cascader {
        width: 100%;
      }
      .el-select {
        width: 100%;
      }
      .login-title {
        padding-bottom: 15px;
        text-align: center;
      }
      .login_bit {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
</style>